import { FC, useEffect } from 'react';
import { ICountryExchangeDetail } from '../../../../../types/countries';
import { IProductDetailId } from '../../../../../types/products';
import { PricingDataByCountry } from './Components';
import { AddCountry } from '../../../../countriesList/components';
import PricingForm from './Components/PricingForm/PricingForm';
import useCatalogueState from '../../../../../state/useCatalogueState';
import './Pricing.scss';

interface IProductForm {
  numberTab: number;
  productDataDetail?: IProductDetailId;
  countriesOpenForSale?: ICountryExchangeDetail[];
  setVerifyPricing: (areVerified: boolean) => void;
  setChangePricing: (change: boolean) => void;
}

const Pricing: FC<IProductForm> = ({
  numberTab,
  productDataDetail,
  countriesOpenForSale,
  setVerifyPricing,
  setChangePricing
}: IProductForm) => {
  const productPricingDataByCountry = productDataDetail?.pricingData;
  const hasCountryData =
    productPricingDataByCountry && productPricingDataByCountry.length > 0 && !!productPricingDataByCountry[0];
  const { showPricingForm, setShowPricingForm } = useCatalogueState();

  const handlePricingFormChange = () => {
    setVerifyPricing(true)
    setChangePricing(true);
  };

  useEffect(() => {
    handlePricingFormChange();

    //eslint-disable-next-line
  }, [showPricingForm]);

  return (
    <section className="pricingTabSection" style={{ display: numberTab !== 3 ? 'none' : '' }}>
      {hasCountryData &&
        productPricingDataByCountry.map(countryData => {
          return (
            <PricingDataByCountry
              key={`countryData-${countryData?.name}`}
              currencyCode={countryData?.currency || countryData?.currencyCode || ''}
              flag={countryData?.flag}
              countryName={countryData?.name}
              preloadedProviderPrice={countryData?.providerPrice ? +countryData.providerPrice : undefined}
              preloadedMargin={countryData?.margin ? +countryData.margin : undefined}
              preloadedStatus={countryData?.productStatus || ''}
              preloadedExchangeRate={+countryData?.exchangeRate}
              preloadedTaxRate={countryData?.taxRate ? +countryData.taxRate : undefined}
              preloadedNudosPriceUsdWithTaxes={
                countryData?.nudosPriceUsdWithTaxes ? +countryData?.nudosPriceUsdWithTaxes : undefined
              }
              preloadedNudosPriceUsd={countryData?.nudosPriceUsd ? +countryData?.nudosPriceUsd : undefined}
              id={countryData.id}
              countryNameCode={countryData?.nameCode}
              setVerifyPricing={setVerifyPricing}
              setChangePricing={setChangePricing}
              countriesOpenForSale={countriesOpenForSale}
              availableProviders={countryData.availableProviders}
              providerId={countryData.providerId || null}
              pricingisActive={Boolean(countryData.isActive)}
            />
          );
        })}

      {!showPricingForm && <AddCountry action={() => setShowPricingForm(!showPricingForm)} className="mt-10" />}
      {showPricingForm && (
        <PricingForm
          showPricingForm={showPricingForm}
          setShowPricingForm={setShowPricingForm}
          setVerifyPricing={setVerifyPricing}
          productDataDetail={productDataDetail}
        />
      )}
    </section>
  );
};

export default Pricing;
